/**
 * Created by Jerker Nord on 2019-04-04.
 */
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite, TimelineMax} from "gsap";
import {ThorGameConfig} from "../ThorGameConfig";
import {ThorSoundConfig} from "../ThorSoundConfig";

export class AnimatedScatter {

    private _scatterSymbol:StateReelSymbol;
    private _firstScatterIdleTL:TimelineMax;
    private _playFirstScatterIdleAnimation:boolean = true;
    private _moreScatterLandTL:TimelineLite;
    private _moreScatterIdleTL:TimelineMax;
    private _scatterCollectTL:TimelineLite;
    private _firstScatterLandTL:TimelineLite;
    private _reelId:number;
    private _symbolPosition:number;
    private _scatterCollected:boolean = false;

    constructor(reelId:number, symbolPosition:number) {
        this._reelId = reelId;
        this._symbolPosition = symbolPosition;
    }

    public playFirstScatterLandAnimation():void {
        if(this._firstScatterLandTL && this._firstScatterLandTL.isActive()) {
            this._firstScatterLandTL.pause();
            this._firstScatterLandTL.kill();
        }
        this._firstScatterLandTL = new TimelineLite({onComplete : () => this.onFirstScatterLandComplete()});
        this._firstScatterLandTL.add(this._scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.land_1}));
    }

    private onFirstScatterLandComplete():void {
        if(this._playFirstScatterIdleAnimation == true) {
            this._firstScatterIdleTL = new TimelineMax({repeat : -1});
            this._firstScatterIdleTL.add(this._scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.idleScatter_1}));
            this._firstScatterIdleTL.add(this._scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.idleScatter_1}));
        }
    }

    public setScatterToNormalState():void {
        if(this._firstScatterIdleTL && this._firstScatterIdleTL.isActive()) {
            this._firstScatterIdleTL.pause();
            this._firstScatterIdleTL.kill();
        }
        this._scatterSymbol.changeState({
            state : ThorGameConfig.instance.SYMBOL_STATES.normal,
            fadeInDuration : 0.5
        });
    }

    public abortScatterToNormalState():void {
        this.stopMoreScatterTimeline();
        if(this._firstScatterLandTL && this._firstScatterLandTL.isActive()) {
            this._firstScatterLandTL.pause();
            this._firstScatterLandTL.kill();
        }
        if(this._firstScatterIdleTL && this._firstScatterIdleTL.isActive()) {
            this._firstScatterIdleTL.pause();
            this._firstScatterIdleTL.kill();
        }
        if(this._moreScatterIdleTL && this._moreScatterIdleTL.isActive()) {
            this._moreScatterIdleTL.pause();
            this._moreScatterIdleTL.kill();
        }
        if(this._scatterCollectTL && this._scatterCollectTL.isActive()) {
            this._scatterCollectTL.pause();
            this._scatterCollectTL.kill();
        }
        this._scatterSymbol.changeState({
            state : ThorGameConfig.instance.SYMBOL_STATES.normal,
            fadeInDuration : 0.5
        });
    }

    public playMoreScatterTimeline():void {
        this._moreScatterLandTL = new TimelineLite({});
        this._moreScatterLandTL.add(this._scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.attention}));
        this._moreScatterLandTL.add(this.onMoreScatterLandComplete(this._scatterSymbol));
    }

    private onMoreScatterLandComplete(scatterSymbol:StateReelSymbol):TimelineMax {
        if(this._moreScatterIdleTL && this._moreScatterIdleTL.isActive()) {
            this._moreScatterIdleTL.pause();
            this._moreScatterIdleTL.kill();
        }
        this._moreScatterIdleTL = new TimelineMax({repeat : -1});
        this._moreScatterIdleTL.add(<Timeline>scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.idleScatter_2}));
        this._moreScatterIdleTL.add(<Timeline>scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.idleScatter_2}));
        return this._moreScatterIdleTL;
    }

    public playScatterCollectTL():void {
        if(this._scatterCollectTL && this._scatterCollectTL.isActive()) {
            this._scatterCollectTL.pause();
            this._scatterCollectTL.kill();
        }
        this._scatterCollectTL = new TimelineLite({});
        this._scatterCollectTL.add(() => this._scatterCollected = true);
        this._scatterCollectTL.add([
            this._scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.nudgeOut}),
            () => SlotGame.sound.playEffect(ThorSoundConfig.instance.SCATTER_CRACK)
        ]);
        this._scatterCollectTL.add(this._scatterSymbol.changeState({state : ThorGameConfig.instance.SYMBOL_STATES.nudgeOutReversed}));
        this._scatterCollectTL.add(this._scatterSymbol.changeState({
            state : ThorGameConfig.instance.SYMBOL_STATES.normal,
            fadeInDuration : 0.4
        }));
    }

    public stopMoreScatterTimeline():void {
        if(this._moreScatterLandTL && this._moreScatterLandTL.isActive()) {
            this._moreScatterLandTL.pause();
            this._moreScatterLandTL.kill();
        }
    }

    set scatterSymbol(value:StateReelSymbol) {
        this._scatterSymbol = value;
    }

    get scatterSymbol():StateReelSymbol {
        return this._scatterSymbol;
    }

    set playFirstScatterIdleAnimation(value:boolean) {
        this._playFirstScatterIdleAnimation = value;
        if(this._playFirstScatterIdleAnimation == false) {
            if(this._firstScatterIdleTL && this._firstScatterIdleTL.isActive()) {
                this._firstScatterIdleTL.pause();
                this._firstScatterIdleTL.kill();
            }
        }
    }

    get reelId():number {
        return this._reelId;
    }

    get symbolPosition():number {
        return this._symbolPosition;
    }

    get scatterCollected():boolean {
        return this._scatterCollected;
    }

    set scatterCollected(value:boolean) {
        this._scatterCollected = value;
    }
}